import { io } from 'socket.io-client';
import store from './redux/stores/GameStore';
import { showToast } from './redux/stores/GameStore';

// Get the backend URL
const getBackendURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_multiplayer_url || 'http://localhost:8000';
  }
  return 'http://localhost:8000';
};

const URL = getBackendURL();
console.log('Connecting to backend at:', URL);

// Create socket with autoConnect disabled initially
// This allows React to control when to connect
export const socket = io(URL, {
  autoConnect: false, // Don't connect immediately
  reconnection: true, // Enable automatic reconnection
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
  transports: ['websocket', 'polling'], // Try websocket first, fallback to polling
});

// Helper function to map error messages to user-friendly text
const getErrorMessage = (error) => {
  const errorMessage = error?.message || error?.toString() || 'Unknown error';
  
  // Map common error patterns to user-friendly messages
  if (errorMessage.includes('room') && errorMessage.includes('not found')) {
    return 'Game room not found';
  }
  if (errorMessage.includes('rate limit') || errorMessage.includes('too many')) {
    return 'Rate limit: too many requests';
  }
  if (errorMessage.includes('join') || errorMessage.includes('room')) {
    return 'Failed to join room';
  }
  if (errorMessage.includes('connection') || errorMessage.includes('connect')) {
    return 'Connection failed. Please try again.';
  }
  
  return errorMessage;
};

// Add error handlers with user-visible notifications
socket.on('connect', () => {
  console.log('✅ Socket connected! ID:', socket.id);
});

socket.on('connect_error', (error) => {
  console.error('❌ Socket connection error:', error.message);
  console.error('Error details:', error);
  store.dispatch(showToast({ 
    message: getErrorMessage(error), 
    type: 'error' 
  }));
});

socket.on('disconnect', (reason) => {
  console.warn('⚠️ Socket disconnected:', reason);
  if (reason === 'io server disconnect') {
    // Server disconnected the socket, reconnect manually
    socket.connect();
  }
});

socket.on('error', (error) => {
  console.error('❌ Socket error:', error);
  store.dispatch(showToast({ 
    message: getErrorMessage(error), 
    type: 'error' 
  }));
});

// Listen for custom error events from the server
socket.on('room_error', (error) => {
  console.error('❌ Room error:', error);
  store.dispatch(showToast({ 
    message: getErrorMessage(error), 
    type: 'error' 
  }));
});

socket.on('join_error', (error) => {
  console.error('❌ Join error:', error);
  store.dispatch(showToast({ 
    message: getErrorMessage(error) || 'Failed to join room', 
    type: 'error' 
  }));
});
